import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import reali1 from "../../assets/r1.png";
import reali12 from "../../assets/r12.png";
import reali13 from "../../assets/r13.png";
import reali14 from "../../assets/r14.png";
import reali15 from "../../assets/r15.png";
import reali16 from "../../assets/r16.png";
import reali17 from "../../assets/r17.png";
import reali18 from "../../assets/r18.png";
import reali19 from "../../assets/r19.png";
import reali112 from "../../assets/r112.png";
import reali113 from "../../assets/r113.png";
import reali114 from "../../assets/r114.png";
import reali115 from "../../assets/r115.png";
import video1 from "../../assets/video1.mp4";
import video2 from "../../assets/video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";
import reali2 from "../../assets/r2.jpg";
import reali22 from "../../assets/reali22.jpg";
import reali23 from "../../assets/reali23.jpg";
import reali3 from "../../assets/r3.jpg";
import reali32 from "../../assets/rea32.jpg";
import AppButton from "../appButton";
import RealisationService from "../../services/realisation/realisation.service";
import { showErrorToaster } from "../toaster/error";
import { useNavigate, useParams } from "react-router-dom";
import StickyButton from "../StickyButton";
import rightArrow from "../../assets/btn-next.png";
import leftArrow from "../../assets/btn-suiv.png";
const realisationService = new RealisationService();

const RealisationListe = () => {
  const [realisations, setRealisation] = useState([]);
  const [activeIndexes, setActiveIndexes] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const imageListe = [
    [
      reali1,
      reali12,
      reali13,
      reali14,
      reali15,
      video2,
      reali16,
      reali17,
      reali18,
      reali19,
      reali112,
      video3,
      reali113,
      reali114,
      reali115,
      video1,

      video4,
    ],
    [reali2, reali32],
    [reali3, reali22, reali23],
  ]; // Tableau des images

  const loadData = async () => {
    try {
      const res = await realisationService?.getAllActiveRealisation();
      setRealisation(res?.data);
      setActiveIndexes(new Array(res?.data.length).fill(0));
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
  };

  useEffect(() => {
    console.log("ID:", id);
    console.log("Realisations:", realisations);

    if (id && realisations.length > 0) {
      const element = document.getElementById(`list-item-${id}`);
      console.log("Element trouvé :", element);

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [id, realisations]);

  useEffect(() => {
    loadData();
  }, []);
  const handlePrevImage = (currentGroupIndex) => {
    setActiveIndexes((prevIndexes) => {
      const newIndexes = [...prevIndexes];
      newIndexes[currentGroupIndex] =
        (newIndexes[currentGroupIndex] -
          1 +
          imageListe[currentGroupIndex].length) %
        imageListe[currentGroupIndex].length;
      return newIndexes;
    });
  };

  const handleNextImage = (currentGroupIndex) => {
    setActiveIndexes((prevIndexes) => {
      const newIndexes = [...prevIndexes];
      newIndexes[currentGroupIndex] =
        (newIndexes[currentGroupIndex] + 1) %
        imageListe[currentGroupIndex].length;
      return newIndexes;
    });
  };
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(candidatureId) {
    return `${apiUrl}/realisation/${candidatureId}/image`;
  }

  return (
    <section>
      <div className="top-con-rea">
        <div className="container-reali mt-reali">
          {realisations.map((realisation, index) => (
            <div
              className={`row mb-4 g-0  ${
                index % 2 === 0 ? "flex-row-reverse " : ""
              }`}
              id={`list-item-${realisation.id}`}
              key={realisation.id}
            >
              <div className="col-lg-6 col-mobile">
                <div className="card-content-reali h-100">
                  {index < 3 ? (
                    <div className="carousel h-100">
                      {/* Carrousel d'images */}
                      <div className="d-flex justify-content-center h-100">
                        <button
                          onClick={() => handlePrevImage(index)}
                          className="btn-prev"
                        >
                          <img
                            src={leftArrow}
                            alt="Précédent"
                            className="arrow-icon"
                          />
                        </button>
                        <div className="carousel-inner">
                          {imageListe[index % imageListe.length][
                            activeIndexes[index]
                          ].endsWith(".mp4") ? (
                            // Afficher une vidéo si le fichier est un MP4
                            <video
                              controls
                              loop
                              className={`card-image-reali ${
                                index % 2 === 0 ? "img-right" : "img-left"
                              } w-100 h-auto height-img `}
                            >
                              <source
                                src={
                                  imageListe[index % imageListe.length][
                                    activeIndexes[index]
                                  ]
                                }
                                type="video/mp4"
                              />
                              Votre navigateur ne supporte pas les vidéos HTML5.
                            </video>
                          ) : (
                            // Sinon, afficher une image
                            <img
                              src={
                                imageListe[index % imageListe.length][
                                  activeIndexes[index]
                                ]
                              }
                              alt={`Illustration ${realisation.title}`}
                              className={`card-image-reali ${
                                index % 2 === 0 ? "img-right" : "img-left"
                              } w-100 h-100`}
                            />
                          )}
                        </div>

                        <button
                          onClick={() => handleNextImage(index)}
                          className="btn-next"
                        >
                          <img
                            src={rightArrow}
                            alt="Suivant"
                            className="arrow-icon"
                          />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <img
                      src={getImageURL(realisation?.id)}
                      alt={`Illustration ${realisation.title}`}
                      className={`card-image-reali ${
                        index % 2 === 0 ? "img-right" : "img-left"
                      } w-100 height-img h-100`}
                    />
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className={`card-reali ${
                    index % 2 === 0 ? "card-reali-left" : "card-reali-right"
                  } w-100 h-100 d-flex align-items-center justify-content-center`}
                >
                  <div className="card-text-reali p-5 mt-4">
                    <h3 className="card-title-reali">{realisation.title}</h3>
                    <p className="card-date-reali">{realisation.date}</p>
                    {realisation.description}
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="row mb-4 " id={`list-item-1000`}>
            <div className="col-lg-12">
              <div
                className={`card-reali card-reali-border  w-100 h-100 d-flex align-items-center justify-content-center`}
              >
                <div className="card-text-reali p-5 mt-4">
                  <h3 className="card-title-reali">
                    Développement d’infrastructures locales
                  </h3>
                  <p className="card-date-reali">01/09/2023</p>
                  Au-delà des forages, la fondation investit dans l’amélioration
                  des infrastructures locales, telles que la construction de
                  ponts, de routes ou de structures sanitaires. Ces projets
                  permettent aux communautés de mieux se connecter aux centres
                  urbains, de faciliter l’accès aux soins de santé et
                  d’améliorer la qualité de vie générale des habitants.
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-4 " id={`list-item-1001`}>
            <div className="col-lg-12">
              <div
                className={`card-reali card-reali-border  w-100 h-100 d-flex align-items-center justify-content-center`}
              >
                <div className="card-text-reali p-5 mt-4">
                  <h3 className="card-title-reali">
                    Soutien aux communautés durant les crises
                  </h3>
                  <p className="card-date-reali">01/09/2023</p>
                  Lors de crises humanitaires, telles que les conflits armés ou
                  les catastrophes naturelles, la fondation a été présente pour
                  apporter un soutien immédiat. Que ce soit par l’envoi de
                  secours d’urgence ou la mise en place de centres temporaires
                  d’hébergement, nous nous efforçons de répondre rapidement aux
                  besoins des populations touchées.
                </div>
              </div>
            </div>
          </div>
          <div className="btn-container-r">
            <AppButton
              text="CONTACTEZ-NOUS"
              className="width_mobile"
              color="bleu"
              size="large"
              onClick={() => {
                navigate("/contact");
                window.scrollTo(0, 0);
              }}
            />
            <AppButton
              text="Faire un don"
              className="width_mobile width-total1"
              color="orange"
              size="large"
              onClick={() => {
                navigate("/faire-don");
                window.scrollTo(0, 0);
              }}
            />
          </div>
        </div>
        <div className="sticky-rea">
          <StickyButton />
        </div>
      </div>
    </section>
  );
};

export default RealisationListe;
